<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Recovery Details EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2 fieldName">
            In EMR
          </div>
          <div class="col-2 fieldName">
            In OATS
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="organSpecification"
              disabled
              label="Organ Specification"
              :class="{ highlightField: isDifferent(organSpecification, organSpecificationOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="organSpecificationOATS"
              disabled
              label="Organ Specification"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="surgeonOne"
              disabled
              label="Surgeon One"
              :class="{ highlightField: isDifferent(surgeonOne, surgeonOneOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="surgeonOneOATS"
              disabled
              label="Surgeon One"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryStartDate"
              disabled
              label="Recovery Start Date"
              :class="{ highlightField: isDifferent(recoveryStartDate, recoveryStartDateOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryStartDateOATS"
              disabled
              label="Recovery Start Date"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryStartTime"
              disabled
              label="Recovery Start Time"
              :class="{ highlightField: isDifferent(recoveryStartTime, recoveryStartTimeOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryStartTimeOATS"
              disabled
              label="Recovery Start Time"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryEndDate"
              disabled
              label="Recovery End Date"
              :class="{ highlightField: isDifferent(recoveryEndDate, recoveryEndDateOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryEndDateOATS"
              disabled
              label="Recovery End Date"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryEndTime"
              disabled
              label="Recovery End Time"
              :class="{ highlightField: isDifferent(recoveryEndTime, recoveryEndTimeOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryEndTimeOATS"
              disabled
              label="Recovery End Time"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="crossClampDate"
              disabled
              label="Cross Clamp Date"
              :class="{ highlightField: isDifferent(crossClampDate, crossClampDateOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="crossClampDateOATS"
              disabled
              label="Cross Clamp Date"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="crossClampTime"
              disabled
              label="Cross Clamp Time"
              :class="{ highlightField: isDifferent(crossClampTime, crossClampTimeOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="crossClampTimeOATS"
              disabled
              label="Cross Clamp Time"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="flushDate"
              disabled
              label="Flush Date"
              :class="{ highlightField: isDifferent(flushDate, flushDateOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="flushDateOATS"
              disabled
              label="Flush Date"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="flushTime"
              disabled
              label="Flush Time"
              :class="{ highlightField: isDifferent(flushTime, flushTimeOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="flushTimeOATS"
              disabled
              label="Flush Time"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="comments"
              disabled
              label="Comments"
              :class="{ highlightField: isDifferent(comments, commentsOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="commentsOATS"
              disabled
              label="Comments"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="completed"
              disabled
              label="Completed"
              :class="{ highlightField: isDifferent(completed, completedOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="completedOATS"
              disabled
              label="Completed"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="organShipped"
              disabled
              label="Organ Shipped"
              :class="{ highlightField: isDifferent(organShipped, organShippedOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="organShippedOATS"
              disabled
              label="Organ Shipped"
            />
          </div>
        </div>
        <div class="row" v-if="organShipped?.toLowerCase() !== 'no'">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="shippedOutOfProvince"
              disabled
              label="Shipped OOP"
              :class="{ highlightField: isDifferent(shippedOutOfProvince, shippedOutOfProvinceOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="shippedOutOfProvinceOATS"
              disabled
              label="Shipped OOP"
            />
          </div>
        </div>
        <div class="row" v-if="shippedOutOfProvince === 'Yes'">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="successfullyTransplanted"
              disabled
              label="Successfully Transplanted"
              :class="{ highlightField: isDifferent(successfullyTransplanted, successfullyTransplantedOATS) }"
            />
          </div> 
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="successfullyTransplantedOATS"
              disabled
              label="Successfully Transplanted"
            />
          </div>
        </div>
        <div class="row" v-if="organ === 'Liver'">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="liverGraftWeight"
              disabled
              label="Liver Graft Weight"
              :class="{ highlightField: isDifferent(liverGraftWeight, liverGraftWeightOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="liverGraftWeightOATS"
              disabled
              label="Liver Graft Weight"
            />
          </div>
        </div>
        <div class="row" v-if="organ === 'Liver'">
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="liverAbnormalitiesConcerns"
              disabled
              label="Liver Abnormalities Concerns"
              class="liverabnormalitiesconcerns"
              :class="{ highlightField: isDifferent(liverAbnormalitiesConcerns, liverAbnormalitiesConcernsOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="liverAbnormalitiesConcernsOATS"
              disabled
              label="Liver Abnormalities Concerns"
              class="liverabnormalitiesconcerns"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>
  
  <script>
  import _ from 'lodash';
  
  // Mirrors backend `value_conversions.js` ValueConversions.ORGAN_SPEC (canonical label per code)
  const ORGAN_SPEC_CODE_TO_TEXT = Object.freeze( {
    '311': 'RIGHT KIDNEY',
    '312': 'LEFT KIDNEY',
    '102': 'Right Liver Lobe',
    '103': 'Left Liver Lobe',
    '452': 'Lung - Right Lobe',
    '453': 'Lung - Left Lobe',
    '402': 'Lung - Right',
    '403': 'Lung - Left',
    '401': 'Lung - Both',
  } );
  
  export default {
    name: "RecoveryDetailsSectionEMROATS",
    props: {
      patient: {
        type: Object,
        default: null,
      },
      patientBundle: {
        type: Object,
        default: null,
      },
      patientBundleOATS: {
        type: Object,
        default: null,
      },
      organ: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        organSpecification: this.getOrganSpecification( this.patientBundle ),
        organSpecificationOATS: this.getOrganSpecificationOATS( this.patientBundleOATS ),
        surgeonOne: this.getSurgeonOne( this.patientBundle ),
        surgeonOneOATS: this.getSurgeonOneOATS( this.patientBundleOATS ),
        recoveryStartDate: this.getRecoveryStartDate( this.patientBundle )?.substring( 0,10 ),
        recoveryStartDateOATS: this.getRecoveryStartDateOATS( this.patientBundleOATS )?.substring( 0,10 ),
        recoveryStartTime: this.getRecoveryStartTime( this.patientBundle )?.substring( 11,19 ),
        recoveryStartTimeOATS: this.getRecoveryStartTimeOATS( this.patientBundleOATS ),
        recoveryEndTime: this.getRecoveryEndTime( this.patientBundle )?.substring( 11,19 ),
        recoveryEndTimeOATS: this.getRecoveryEndTimeOATS( this.patientBundleOATS ),
        recoveryEndDate: this.getRecoveryEndDate( this.patientBundle )?.substring( 0,10 ),
        recoveryEndDateOATS: this.getRecoveryEndDateOATS( this.patientBundleOATS )?.substring( 0,10 ),
        crossClampDate: this.getCrossClampDate( this.patientBundle )?.substring( 0,10 ), 
        crossClampDateOATS: this.getCrossClampDateOATS( this.patientBundleOATS )?.substring( 0,10 ),
        crossClampTime: this.getCrossClampTime( this.patientBundle )?.substring( 11,19 ),
        crossClampTimeOATS: this.getCrossClampTimeOATS( this.patientBundleOATS ),
        flushDate: this.getFlushDate( this.patientBundle )?.substring( 0,10 ),
        flushDateOATS: this.getFlushDateOATS( this.patientBundleOATS )?.substring( 0,10 ),
        flushTime: this.getFlushTime( this.patientBundle )?.substring( 11,19 ),
        flushTimeOATS: this.getFlushTimeOATS( this.patientBundleOATS ),
        comments: this.getComments( this.patientBundle ),
        commentsOATS: this.getCommentsOATS( this.patientBundleOATS ),
        completed: this.getCompleted( this.patientBundle ),
        completedOATS: this.getCompletedOATS( this.patientBundleOATS ),
        organShipped: this.getOrganShipped( this.patientBundle ),
        organShippedOATS: this.getOrganShippedOATS( this.patientBundleOATS ),
        shippedOutOfProvince: this.getShippedOutOfProvince( this.patientBundle ),
        shippedOutOfProvinceOATS: this.getShippedOutOfProvinceOATS( this.patientBundleOATS ),
        // perfusionPump: this.getPerfusionPump( this.patientBundle ),
        // perfusionPumpOATS: this.getPerfusionPumpOATS( this.patientBundleOATS ),
        // perfusionDate: this.getPerfusionDate( this.patientBundle ),
        // perfusionDateOATS: this.getPerfusionDateOATS( this.patientBundleOATS ),
        // perfusionTimeOATS: this.getPerfusionTimeOATS( this.patientBundleOATS ),
        successfullyTransplanted: this.getOrganSuccessfullyTransplanted( this.patientBundle ),
        successfullyTransplantedOATS: this.getOrganSuccessfullyTransplantedOATS( this.patientBundleOATS ),
        liverGraftWeight: this.getLiverGraftWeight( this.patientBundle ),
        liverGraftWeightOATS: this.getLiverGraftWeightOATS( this.patientBundleOATS ),
        liverAbnormalitiesConcerns: this.getLiverAbnormalitiesConcerns( this.patientBundle ),
        liverAbnormalitiesConcernsOATS: this.getLiverAbnormalitiesConcernsOATS( this.patientBundleOATS ),
      };
      },
     mounted() {
      
      },
    methods: {
      combineProps() {
        return `${this.patient}`;
      },
      isDifferent( a, b ) {
        return String( a ?? '' ).trim().toLowerCase() !== String( b ?? '' ).trim().toLowerCase();
    },
    _getOatsDateAdjusted( date ) {
        const raw = date;
        if( !raw ) return null;
        const ms = Date.parse( raw );
        if( Number.isNaN( ms ) ) {
          return {
            date: raw.length >= 10 ? raw.substring( 0, 10 ) : null,
            time: raw.length >= 16 ? raw.substring( 11, 16 ) : null,
          };
        }
        const adjusted = new Date( ms - ( 4 * 60 ) * 60 * 1000 );
        const y = adjusted.getUTCFullYear();
        const mo = String( adjusted.getUTCMonth() + 1 ).padStart( 2, '0' );
        const d = String( adjusted.getUTCDate() ).padStart( 2, '0' );
        const hh = String( adjusted.getUTCHours() ).padStart( 2, '0' );
        const mm = String( adjusted.getUTCMinutes() ).padStart( 2, '0' );
        return { date: `${y}-${mo}-${d}`, time: `${hh}:${mm}` };
      },
      getOrganSpecification( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let organSpecification = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#395' ) ) ;
      if( organSpecification && organSpecification[ 0 ] ) {
        return _.get( organSpecification[0], 'resource.component[0].valueString' );
      } 
      }
      },
      getOrganSpecificationOATS( patientBundleOATS ) {
        const organSpecCode = patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.organ_specification_code;
        if( organSpecCode == null || organSpecCode === '' ) return organSpecCode;
  
        const mapped = ORGAN_SPEC_CODE_TO_TEXT[ String( organSpecCode ) ];
        return mapped ?? organSpecCode;
      },
      getSurgeonOne( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let surgeonOne = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#112' ) ) ;
      if( surgeonOne && surgeonOne[ 0 ] ) {
        return _.get( surgeonOne[0], 'resource.component[0].valueString' );
      } 
      }
      },
      getSurgeonOneOATS( patientBundleOATS ) {
        return patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.surgeon1;
      },
      getRecoveryStartDate( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let recoveryStartDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#398' ) ) ;
      if( recoveryStartDate && recoveryStartDate[ 0 ] ) {
        return _.get( recoveryStartDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
      },
      getRecoveryStartDateOATS( patientBundleOATS ) {
        //return this._getOatsDateAdjusted( patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.start_date )?.date;
        return patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.start_date?.substring( 0,10 );
      },
      getRecoveryStartTime( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let recoveryStartDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#398' ) ) ;
      if( recoveryStartDate && recoveryStartDate[ 0 ] ) {
        return _.get( recoveryStartDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
      },
      getRecoveryStartTimeOATS( patientBundleOATS ) {
        //return this._getOatsDateAdjusted( patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.start_date )?.time;
        return patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.start_date?.substring( 11,19 );
      },
      getRecoveryEndDate( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let recoveryEndDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#399' ) ) ;
      if( recoveryEndDate && recoveryEndDate[ 0 ] ) {
        return _.get( recoveryEndDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
      },
      getRecoveryEndDateOATS( patientBundleOATS ) {
        //return this._getOatsDateAdjusted( patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.end_date )?.date;
        return patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.end_date?.substring( 0,10 );
      },
      getRecoveryEndTime( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let recoveryEndDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#399' ) ) ;
      if( recoveryEndDate && recoveryEndDate[ 0 ] ) {
        return _.get( recoveryEndDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
      },
      getRecoveryEndTimeOATS( patientBundleOATS ) {
        //return this._getOatsDateAdjusted( patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.end_date )?.time;
        return patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.end_date?.substring( 11,19 );
      },
      getCrossClampDate( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let crossClampDate= observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#400' ) ) ;
      if( crossClampDate && crossClampDate[ 0 ] ) {
        return _.get( crossClampDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
      },
      getCrossClampDateOATS( patientBundleOATS ) {
        //return this._getOatsDateAdjusted( patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.cross_clamp_date )?.date;
        return patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.cross_clamp_date?.substring( 0,10 );
      },
      getCrossClampTime( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let crossClampDate= observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#400' ) ) ;
      if( crossClampDate && crossClampDate[ 0 ] ) {
        return _.get( crossClampDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
      },
      getCrossClampTimeOATS( patientBundleOATS ) {
        //return this._getOatsDateAdjusted( patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.cross_clamp_date )?.time;
        return patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.cross_clamp_date?.substring( 11,19 );
      },
      getFlushDate( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#114' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
      },
      getFlushDateOATS( patientBundleOATS ) {
        //return this._getOatsDateAdjusted( patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.flush_date )?.date;
        return patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.flush_date?.substring( 0,10 );
      },
      getFlushTime( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#114' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
        }
      },
      getFlushTimeOATS( patientBundleOATS ) {
        //return this._getOatsDateAdjusted( patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.flush_date )?.time;
        return patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.flush_date?.substring( 11,19 );
      },
      getComments( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16539' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueString' ); 
      } 
      }
      },
      getCommentsOATS( patientBundleOATS ) {
        return patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.comments;
      },
      getCompleted( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16540' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
      },
      getCompletedOATS( patientBundleOATS ) {
        let completedOATS = patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.completed;
        if( completedOATS == null || completedOATS === '' ) return completedOATS;
        if( completedOATS === true ) return 'Yes';
        if( completedOATS === false ) return 'No';
        return completedOATS;
      },
      getOrganShipped( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16542' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
      },
      getOrganShippedOATS( patientBundleOATS ) {
        let organShippedOATS = patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.organ_shipped;
        if( organShippedOATS == null || organShippedOATS === '' ) return '';
        if( organShippedOATS === true ) return 'Yes';
        if( organShippedOATS === false ) return 'No';
        return organShippedOATS;
      },
      getShippedOutOfProvince( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16569' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
      },
      getShippedOutOfProvinceOATS( patientBundleOATS ) {
        let shippedOutOfProvinceOATS = patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.organ_shipped_info?.oop;
        if( shippedOutOfProvinceOATS == null || shippedOutOfProvinceOATS === '' ) return shippedOutOfProvinceOATS;
        if( shippedOutOfProvinceOATS === true ) return 'Yes';
        if( shippedOutOfProvinceOATS === false ) return 'No';
        return shippedOutOfProvinceOATS;
      },
    //   getPerfusionPump( patientBundle ) {
    //     let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
    //       _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
    //     if( observation && observation[ 0 ] ) {
    //       let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16571' ) ) ;
    //     if( flushDate && flushDate[ 0 ] ) {
    //       return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
    //     } 
    //     }
    //   },
    //   getPerfusionPumpOATS( patientBundleOATS ) {
    //     let perfusionPumpOATS = patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.organ_shipped_info?.perfusion_pump;
    //     if( perfusionPumpOATS == null || perfusionPumpOATS === '' ) return 'No';
    //     if( perfusionPumpOATS === true ) return 'Yes';
    //     if( perfusionPumpOATS === false ) return 'No';
    //     return perfusionPumpOATS;
    //   },
    //   getPerfusionDate( patientBundle ) {
    //     let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
    //       _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
    //     if( observation && observation[ 0 ] ) {
    //       let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4059' ) ) ;
    //     if( flushDate && flushDate[ 0 ] ) {
    //       return _.get( flushDate[ 0 ], 'resource.component[0].valueDateTime' )?.substring( 0,10 );
    //     } 
    //     }
    //   },
    //   getPerfusionDateOATS( patientBundleOATS ) {
    //     return this._getOatsDateAdjusted( patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.organ_shipped_info?.perfusion_date )?.date;
    //   },
    //   getPerfusionTimeOATS( patientBundleOATS ) {
    //     return this._getOatsDateAdjusted( patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.organ_shipped_info?.perfusion_date )?.time;
    //   },
      getOrganSuccessfullyTransplanted( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16573' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
      },
      getOrganSuccessfullyTransplantedOATS( patientBundleOATS ) {
        let organSuccessfullyTransplantedOATS = patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.organ_shipped_info?.organ_successfully_transplanted;
        if( organSuccessfullyTransplantedOATS == null || organSuccessfullyTransplantedOATS === '' ) return 'No';
        if( organSuccessfullyTransplantedOATS === true ) return 'Yes';
        if( organSuccessfullyTransplantedOATS === false ) return 'No';
        return organSuccessfullyTransplantedOATS;
      },
      getLiverGraftWeight( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
        if( observation && observation[ 0 ] ) {
          let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4078' ) ) ;
        if( flushDate && flushDate[ 0 ] ) {
          return _.get( flushDate[ 0 ], 'resource.component[0].valueString' ); 
        } 
        }
      },
      getLiverGraftWeightOATS( patientBundleOATS ) {
        return patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.liver_graft_weight;
      },
      getLiverAbnormalitiesConcerns( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
        if( observation && observation[ 0 ] ) {
          let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4079' ) ) ;
        if( flushDate && flushDate[ 0 ] ) {
          return _.get( flushDate[ 0 ], 'resource.component[0].valueString' ); 
        } 
        }
      },
      getLiverAbnormalitiesConcernsOATS( patientBundleOATS ) {
        return patientBundleOATS?.living_donor_info?.journeys[0]?.recovery_info?.liver_abnormalities_concerns;
      },
    },
  };
  </script>
  
  <style scoped>
  
  /* .card {
    height: 340px;
  } */
  
  .sectionHeading {
    background-color: rgb(59, 53, 53);
    color: white;
    padding-left: 5px;
  }
  .page-content .summary-card .card-header .summary-name {
    padding-left: 35px;
    padding-top: 4px;
    font-weight: 300;
  }
  
  .sections {
    font-size: 15px;
    height: 2200px;
    width: 1400px;
    /* overflow: scroll; */
    padding-left: 10px;
    /* padding-top: 5px; */
  }
  
  .inputDisplay {
  border-style: solid;
  background-color: #F2F2F2;
  }
  
  .fieldName {
    font-weight: 700;
    font-size: 0.875rem;
    /* padding-top: 5.5px; */
    /* padding-bottom: 2.5px; */
    /* padding-right: 15px; */
    padding-inline-start: 2%;
  }
  
  :deep(.afflo-ds-form-control) {
    width: max-content;
  }
  
  :deep(label) {
    width: max-content;
  }
  
  :deep(.ExceptionalDistributionReasonOther .afflo-ds-form-control) {
    width: 400px;
  }
  
  :deep(.liverabnormalitiesconcerns .afflo-ds-form-control) {
    width: 300px;
  }
  
  .highlightField :deep(.afflo-ds-form-control) {
    border: 2px solid red;
  }
  </style>
  